import React from 'react'
import MoreIcon from "@material-ui/icons/MoreVert";
import ButtonBase from "@material-ui/core/ButtonBase"

function UpdateOrderRows() {
    const lastLogin = "14/APR/2020";
    return (
        <tr>
        <td>
            <input type="checkbox" className="table-checkbox" />
        </td>
        <td>
            <img
                src="https://avatars.dicebear.com/api/initials/Robert.svg"
                className="admin-table-pic"
                alt="Admin table pic"
            />
        </td>
        <td>Robert Fox</td>
        <td>
            <small className="admin-table-status innactive">Innactive</small><br />
            <small className="admin-table-last-login">Last login: {lastLogin}</small>
        </td>
        <td>ericmckin@gmail.com</td>
        <td>400</td>
        <td> <span className="remaining earnings">$300</span></td>
        <td>
            <ButtonBase>
                <MoreIcon style={{ cursor: "pointer", color: "#1D8CFB" }} />
            </ButtonBase>
        </td>
    </tr>
    )
}

export default UpdateOrderRows
